<template>
  <button
    class="primary-button"
    :class="{ 'primary-button_warning': warning, 'primary-okay-btn': okayIcon }"
    v-bind="$props"
    @click="$emit('click', $event)"
    :disabled="isLoading"
  >
    <template v-if="isLoading">
      <svg
        class="svg-icon loading-icon"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        style="background: rgba(224, 102, 102, 0); display: block;"
        width="250px"
        height="250px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <circle
          cx="50"
          cy="50"
          fill="none"
          stroke="#fff"
          stroke-width="14"
          r="40"
          stroke-dasharray="188.49555921538757 64.83185307179586"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            repeatCount="indefinite"
            dur="0.6s"
            values="0 50 50;360 50 50"
            keyTimes="0;1"
          ></animateTransform>
        </circle>
      </svg>
    </template>
    <slot />
  </button>
</template>

<script>
export default {
  name: "PrimaryButton",
  props: {
    warning: {
      type: Boolean,
      default: false
    },
    okayIcon: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/media";

.primary-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  background-color: #009ee3;
  border: none;

  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #ffffff;

  padding: 9.5px 30px;

  cursor: pointer;

  transition: all 0.1s;
  outline: none;
  text-decoration: none;

  &[disabled] {
    background: #cdced0;
    color: #ffffff;
    pointer-events: none;
    touch-action: none;
  }

  &:hover,
  &:focus {
    background: #0070d2;
  }

  &:active {
    background: #005197;
  }

  &_warning {
    background: #f6921c;

    &:hover,
    &:focus {
      background: #d27c18;
    }

    &:active {
      background: #ef8c1a;
    }

    &[disabled] {
      background: #cdced0;
    }
  }

  &--white {
    background: var(--white, #fff);
    border: 1px solid var(--gray-darker, #d5dae5);
    color: var(--main, #009ee3);

    &:hover,
    &:focus {
      background: var(--main-bg, #f0f5f9);
    }

    &:active {
      background: var(--gray-30, #ebecf0);
    }
  }

  .svg-icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  @include respond-down(md) {
    font-size: 12px;
    padding: 9.5px 24px;
  }
}
.primary-okay-btn {
  padding: 0;
  width: 40px;
  height: 40px;

  .svg-icon {
    width: 13px;
    height: 10px;
    color: #fff;
  }
}
</style>
